import { render, staticRenderFns } from "./merchantPayRouter.vue?vue&type=template&id=05a2c8b6"
import script from "./merchantPayRouter.vue?vue&type=script&lang=js"
export * from "./merchantPayRouter.vue?vue&type=script&lang=js"
import style0 from "./merchantPayRouter.vue?vue&type=style&index=0&id=05a2c8b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports